module.exports = __webpack_public_path__ + "media/sounds/tap_01-d101efec73ed0ccdce3646fb791f8ad8.wav";